export enum AccountScreens {
  STEP_ONE_SCREEN = "step1",
  STEP_TWO_SCREEN = "step2",
  STEP_THREE_SCREEN = "step3",
}
